
{
  "familyId": "GET-PROC-TOENAME",
  "questions": [
    {
      "id": "GET-PROC-TOENAME-001",
      "familyId": "GET-PROC-TOENAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_toename",
      "questionType": "multiple_choice",
      "question": "Een fietsenmaker verkoopt een fiets voor €400. De prijs stijgt met 15%. Wat is de nieuwe prijs?",
      "options": [
        "€460",
        "€415",
        "€340",
        "€600"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 0,
            "end": 500,
            "marked": [400, 460],
            "highlight": [60],
            "step": 50,
            "label": "€400 + 15% = €400 + €60 = €460"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Procentuele toename berekenen",
            "content": "Bereken de toename: 15% van €400 = 0,15 × 400 = €60. Tel op: €400 + €60 = €460. Of vermenigvuldig direct met de factor: €400 × 1,15 = €460.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_toename_prijs",
      "variantIndex": 1,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Je berekent eerst de toename: 15% van €400 = 0,15 × 400 = €60. Daarna tel je op bij de oorspronkelijke prijs: €400 + €60 = €460. Je kunt ook direct rekenen met de groeifactor: €400 × 1,15 = €460.",
        "solutionSteps": [
          "Bereken de toename: 15% van €400 = 0,15 × 400 = €60",
          "Tel op bij het oorspronkelijke bedrag: €400 + €60 = €460",
          "Check met factor: €400 × 1,15 = €460 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 15% van 400 = 60. Nieuwe prijs: 400 + 60 = €460.",
          "1": "Je dacht waarschijnlijk dat je 15 optelt bij de prijs. Maar 15% van 400 = 60, niet 15. Onthoud: je moet het percentage berekenen: 0,15 × 400 = 60.",
          "2": "Je dacht waarschijnlijk dat je moet aftrekken. Maar bij een stijging tel je op: 400 + 60 = 460, niet 400 − 60 = 340. Onthoud: stijging = optellen, daling = aftrekken.",
          "3": "Je dacht waarschijnlijk dat 15% = 0,5. Maar 15% = 0,15, dus de factor is 1,15, niet 1,5. Onthoud: 400 × 1,15 = 460, niet 400 × 1,5 = 600."
        }
      }
    },
    {
      "id": "GET-PROC-TOENAME-002",
      "familyId": "GET-PROC-TOENAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_toename",
      "questionType": "multiple_choice",
      "question": "Een stadsplanner meldt dat een stad met 80.000 inwoners 5% is gegroeid. Hoeveel inwoners zijn er nu?",
      "options": [
        "84.000",
        "80.500",
        "85.000",
        "120.000"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 70000,
            "end": 90000,
            "marked": [80000, 84000],
            "highlight": [4000],
            "step": 2000,
            "label": "80.000 + 5% = 80.000 + 4.000 = 84.000"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Toename met factor",
            "content": "Bij een toename van 5% vermenigvuldig je met de factor 1,05. Of bereken: 5% van 80.000 = 0,05 × 80.000 = 4.000. Nieuw: 80.000 + 4.000 = 84.000.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_toename_bevolking",
      "variantIndex": 2,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Je berekent 5% van 80.000: dat is 0,05 × 80.000 = 4.000 inwoners erbij. Het nieuwe inwoneraantal: 80.000 + 4.000 = 84.000. Je kunt ook direct rekenen: 80.000 × 1,05 = 84.000.",
        "solutionSteps": [
          "Bereken de toename: 5% van 80.000 = 0,05 × 80.000 = 4.000",
          "Tel op: 80.000 + 4.000 = 84.000",
          "Check met factor: 80.000 × 1,05 = 84.000 ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! 5% van 80.000 = 4.000. Nieuw: 80.000 + 4.000 = 84.000.",
          "1": "Je dacht waarschijnlijk dat je 500 optelt. Maar 5% van 80.000 = 4.000, niet 500. Onthoud: 0,05 × 80.000 = 4.000.",
          "2": "Je dacht waarschijnlijk dat je 5.000 optelt. Maar 5% ≠ 5.000. Onthoud: bereken het percentage: 0,05 × 80.000 = 4.000.",
          "3": "Je dacht waarschijnlijk dat de factor 1,5 is. Maar 5% = 0,05, dus de factor is 1,05, niet 1,5. Onthoud: 80.000 × 1,05 = 84.000, niet 80.000 × 1,5 = 120.000."
        }
      }
    },
    {
      "id": "GET-PROC-TOENAME-003",
      "familyId": "GET-PROC-TOENAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_toename",
      "questionType": "multiple_choice",
      "question": "Een econoom berekent de groeifactor. Met welke factor vermenigvuldig je bij een toename van 25%?",
      "options": [
        "1,25",
        "0,25",
        "1,025",
        "25"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 0,
            "end": 2,
            "marked": [1, 1.25],
            "highlight": [0.25],
            "step": 0.25,
            "label": "Groeifactor: 1 + 0,25 = 1,25"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Groeifactor berekenen",
            "content": "De groeifactor = 1 + percentage als decimaal. Bij 25% toename: factor = 1 + 0,25 = 1,25. Met deze factor vermenigvuldig je het oorspronkelijke bedrag.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_toename_factor",
      "variantIndex": 3,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "De groeifactor bereken je door het percentage als decimaal op te tellen bij 1. Bij 25% toename: 25% = 0,25. Factor = 1 + 0,25 = 1,25. Met deze factor vermenigvuldig je het oorspronkelijke bedrag om de nieuwe waarde te krijgen.",
        "solutionSteps": [
          "Zet het percentage om naar een decimaal: 25% = 0,25",
          "Tel op bij 1: factor = 1 + 0,25 = 1,25",
          "Check: 1,25 = 125% → 25% meer dan het origineel ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Toename van 25% → factor = 1 + 0,25 = 1,25.",
          "1": "Je dacht waarschijnlijk dat het percentage zelf de factor is. Maar 0,25 is alleen de toename, niet de factor. Onthoud: factor = 1 + 0,25 = 1,25 (je houdt het oorspronkelijke bedrag erbij).",
          "2": "Je dacht waarschijnlijk dat 25% = 0,025. Maar 25% = 0,25 (deel door 100, niet door 1000). Onthoud: 2,5% = 0,025, maar 25% = 0,25.",
          "3": "Je dacht waarschijnlijk dat het percentage zelf als factor werkt. Maar 25 is geen bruikbare factor — je moet het eerst omzetten naar een decimaal. Onthoud: 25% = 0,25, factor = 1,25."
        }
      }
    },
    {
      "id": "GET-PROC-TOENAME-004",
      "familyId": "GET-PROC-TOENAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_toename",
      "questionType": "multiple_choice",
      "question": "Een bankmedewerker berekent de rente. Een spaarrekening van €2.000 groeit met 3,5% rente. Hoeveel staat er na één jaar?",
      "options": [
        "€2.070",
        "€2.035",
        "€2.700",
        "€2.350"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 1900,
            "end": 2200,
            "marked": [2000, 2070],
            "highlight": [70],
            "step": 50,
            "label": "€2.000 + 3,5% = €2.000 + €70 = €2.070"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Rente berekenen",
            "content": "Rente = percentage × spaarbedrag. 3,5% van €2.000 = 0,035 × 2.000 = €70. Nieuw saldo = €2.000 + €70 = €2.070. Of: €2.000 × 1,035 = €2.070.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_toename_rente",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Je berekent de rente: 3,5% van €2.000 = 0,035 × 2.000 = €70. Het nieuwe saldo: €2.000 + €70 = €2.070. Let op de komma in het percentage: 3,5% = 0,035, niet 0,35.",
        "solutionSteps": [
          "Zet het percentage om: 3,5% = 0,035",
          "Bereken de rente: 0,035 × €2.000 = €70",
          "Tel op: €2.000 + €70 = €2.070"
        ],
        "distractorExplanations": {
          "0": "Goed! 3,5% van 2.000 = 70. Na één jaar: 2.000 + 70 = €2.070.",
          "1": "Je dacht waarschijnlijk dat je 35 optelt. Maar 3,5% van 2.000 = 70, niet 35. Onthoud: 3,5% = 0,035, en 0,035 × 2.000 = 70.",
          "2": "Je dacht waarschijnlijk dat 3,5% = 35%. Maar 35% van 2.000 = 700, terwijl 3,5% van 2.000 = 70. Onthoud: let goed op de komma in het percentage.",
          "3": "Je dacht waarschijnlijk dat de factor 1,35 is. Maar 3,5% = 0,035, dus de factor = 1,035, niet 1,35. Onthoud: 2.000 × 1,035 = 2.070, niet 2.000 × 1,35 = 2.350."
        }
      }
    },
    {
      "id": "GET-PROC-TOENAME-005",
      "familyId": "GET-PROC-TOENAME",
      "module": "Getalbegrip",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "procenten",
      "subSkill": "proc_toename",
      "questionType": "fill_in",
      "question": "Een horecaondernemer verhoogt de menuprijs van €12 met 10%. Wat is de nieuwe prijs in euro's?",
      "correctAnswer": "13,20",
      "data": {
        "acceptedAnswers": ["13,20", "13.20", "€13,20", "€ 13,20", "13,2"],
        "placeholder": "€ ...",
        "inputType": "text"
      },
      "stimulusAids": [
        {
          "type": "numberline",
          "data": {
            "start": 10,
            "end": 15,
            "marked": [12, 13.2],
            "highlight": [1.2],
            "step": 0.5,
            "label": "€12 + 10% = €12 + €1,20 = €13,20"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Prijsverhoging berekenen",
            "content": "Bereken de verhoging: 10% van €12 = 0,10 × 12 = €1,20. Tel op: €12 + €1,20 = €13,20. Of direct: €12 × 1,10 = €13,20.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "proc_toename_menuprijs",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Je berekent de verhoging: 10% van €12 = 0,10 × 12 = €1,20. De nieuwe prijs: €12 + €1,20 = €13,20. Je kunt ook direct rekenen: €12 × 1,10 = €13,20. Let op: het antwoord heeft twee decimalen omdat het een geldbedrag is.",
        "solutionSteps": [
          "Bereken de verhoging: 10% van €12 = 0,10 × 12 = €1,20",
          "Tel op: €12 + €1,20 = €13,20",
          "Check met factor: €12 × 1,10 = €13,20 ✓"
        ]
      }
    }
  ]
}
